export interface CampaignsContextValue {
  activeCampaign?: Campaigns
  currentDiscount: number
  applyDiscount: (price: number) => number
}

export enum Campaigns {
  Christmas = 'christmas2024',
  BlackFriday = 'blackFriday2025',
  Christmas2025 = 'christmas2025_2026',
}
